"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.host = exports.currentStage = exports.getEsspHeaders = exports.getApiGatewayHeaders = exports.getCredentials = exports.apiGatewayUrl = exports.Stage = exports.AtoZClientId = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var nanoid_1 = require("nanoid");
var AtoZClientId;
(function (AtoZClientId) {
    AtoZClientId["TIME_OFF"] = "ATOZ_TIMEOFF_SERVICE";
})(AtoZClientId = exports.AtoZClientId || (exports.AtoZClientId = {}));
var Stage;
(function (Stage) {
    Stage["DEV"] = "dev";
    Stage["ESSP"] = "essp";
    Stage["BETA"] = "beta";
    Stage["GAMMA"] = "gamma";
    Stage["PROD"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
exports.apiGatewayUrl = {
    dev: 'http://0.0.0.0:4000',
    essp: 'https://atoz-api.integ.amazon.com',
    beta: 'https://atoz-api.integ.amazon.com',
    gamma: 'https://atoz-api.integ.amazon.com',
    prod: 'https://atoz-api.amazon.work'
};
var getCredentials = function (stage) {
    if (stage === Stage.DEV) {
        return 'same-origin';
    }
    return 'include';
};
exports.getCredentials = getCredentials;
var getApiGatewayHeaders = function (stage, clientId) {
    var headers = {
        'x-atoz-client-id': clientId,
        'x-atoz-client-request-id': (0, nanoid_1.nanoid)()
    };
    if (stage !== Stage.PROD) {
        headers['Authorization'] = "Bearer ".concat(js_cookie_1.default.get('atoz-oauth-token'));
    }
    return headers;
};
exports.getApiGatewayHeaders = getApiGatewayHeaders;
var getEsspHeaders = function () {
    var csrfTokenElement = document.querySelector('meta[name=csrf-token]');
    return {
        Accept: 'text/javascript',
        'X-CSRF-Token': (csrfTokenElement && csrfTokenElement.content) || '',
        'Content-Type': 'application/json'
    };
};
exports.getEsspHeaders = getEsspHeaders;
/**
 * Katal manifest templating will replace {{Stage}} with the correct stage value
 * during build time. Bundle for the appropriate stage will have the correct
 * stage string value used for fetching the url
 * https://katal.corp.amazon.com/#/developer/manifest/templatingcdk
 */
exports.currentStage = '{{Stage}}'.toLowerCase();
exports.host = exports.apiGatewayUrl[exports.currentStage] || exports.apiGatewayUrl[Stage.BETA];
